import events from './events';
import { auctionV2ApiClient } from "./auctions-list-page/AuctionApiClient";
import formatPrice from './utils/formatPrice';
export function auctionWatch() {
    return {
        $el: {},
        auctionItem: {},
        isLoading: false,
        errorMessage: "",
        formatPrice,
        init() {
            this.auctionItem = JSON.parse(this.$el.parentNode.dataset.product);
        },
        initWithData(data) {
            this.auctionItem = data;
        },
        async addToWatchedItems() {
            if (!document.body.dataset.username) {
                events.openLogin.trigger({ open: true, centeredFixed: true });
                return;
            }
            this.isLoading = true;
            this.errorMessage = "";
            try {
                await auctionV2ApiClient.addWatchedItem({
                    itemId: this.auctionItem.id
                });
                this.auctionItem.isWatched = true;
            }
            catch (error) {
                this.errorMessage = error.data.message;
            }
            finally {
                this.isLoading = false;
            }
        },
        async removeFromWatchedItems() {
            this.isLoading = true;
            this.errorMessage = "";
            try {
                await auctionV2ApiClient.removeWatchedItem(this.auctionItem.id);
                this.auctionItem.isWatched = false;
            }
            catch (error) {
                this.errorMessage = error.data.message;
            }
            finally {
                this.isLoading = false;
            }
        }
    };
}
